/**
 * utils/connectionPool/stats.ts — stats/close/status methods for ConnectionPoolManager
 */

import { ConnectionPoolManager } from './manager.js';

declare module './manager.js' {
  interface ConnectionPoolManager {
    getStats(): {
      total: number;
      active: number;
      idle: number;
      queue: number;
    };
    close(): void;
    getStatus(): string;
  }
}

export function applyStatsMethods() {
  Object.assign(ConnectionPoolManager.prototype, {
    /**
     * Get pool statistics
     */
    getStats(): {
        total: number;
        active: number;
        idle: number;
        queue: number;
    } {
        let active = 0;
        for (const conn of this.connections.values()) {
            if (conn.inUse) active++;
        }

        return {
            total: this.connections.size,
            active,
            idle: this.connections.size - active,
            queue: this.acquireQueue.length,
        };
    },

    /**
     * Close all connections
     */
    close(): void {
        this.connections.clear();
        this.acquireQueue = [];
        console.log('[Pool] All connections closed');
    },

    /**
     * Get pool status for monitoring
     */
    getStatus(): string {
        const stats = this.getStats();
        return `[Pool] Total: ${stats.total}, Active: ${stats.active}, Idle: ${stats.idle}, Queue: ${stats.queue}`;
    },
  });
}
